module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBoldItalic.2ecf37e.woff2";